import React from 'react';
import AdminPricingManagement from '../AdminPricingManagement';
import AdminPaymentsManagement from '../AdminPaymentsManagement';
import AdminSecurityDashboard from '../AdminSecurityDashboard';
import AdminSecurityDocuments from '../AdminSecurityDocuments';
import { AdminAccessRequestsTab } from '../AdminAccessRequestsTab';
import { AdminUsersTab } from '../AdminUsersTab';
import AdminSettingsTab from '../AdminSettingsTab';
import BriefingsAdminTab from './BriefingsAdminTab';
import EstateVaultAdminTab from './EstateVaultAdminTab';

const TAB_RENDERERS = {
  requests: (p) => (
    <AdminAccessRequestsTab accessRequests={p.accessRequests} loading={p.loading} filter={p.filter} setFilter={p.setFilter}
      actionLoading={p.actionLoading} onApprove={p.onApprove} onWaitlist={p.onWaitlist} onSelectRequest={p.onSelectRequest} />
  ),
  briefings: () => <BriefingsAdminTab />,
  'estate-vault': () => <EstateVaultAdminTab />,
  users: (p) => <AdminUsersTab refreshKey={p.usersRefreshKey} onDeleteUser={p.onDeleteUser} fetchUsers={p.fetchUsers} isActive={p.activeTab === 'users'} />,
  pricing: () => <div className="bg-gray-800 rounded-xl p-3 sm:p-6 border border-gray-700"><AdminPricingManagement /></div>,
  payments: () => <AdminPaymentsManagement />,
  security: () => (
    <div className="space-y-6">
      <div className="bg-gray-800 rounded-xl p-3 sm:p-6 border border-gray-700"><AdminSecurityDashboard /></div>
      <AdminSecurityDocuments />
    </div>
  ),
  settings: (p) => <AdminSettingsTab admin={p.admin} setAdmin={p.setAdmin} />,
};

export const AdminCoreTabContent = ({ activeTab, ...props }) => {
  const renderer = TAB_RENDERERS[activeTab];
  return renderer ? renderer({ ...props, activeTab }) : null;
};
